export { PageAnchor } from './page-anchor';
